import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { ComponentType } from '@angular/cdk/portal';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DialogService {
  constructor(private dialog: MatDialog) { }

  /**
   * Open a simple modal/dialog
   * @param component - Component to display in modal
   * @param config - Optional MatDialogConfig
   * @returns MatDialogRef
   */
  openDialog<T, R = any>(
    component: ComponentType<T>,
    data: any = null,
    disableClose: boolean = false,
  ): MatDialogRef<T, R> {
    const defaultConfig: MatDialogConfig = {
      disableClose,
      autoFocus: false,
      restoreFocus: true,
      panelClass: 'app-dialog-panel',
      backdropClass: 'app-dialog-backdrop'
    };

    if (data) defaultConfig['data'] = data;

    return this.dialog.open(component, defaultConfig);
  }

  closeModal<R = any>(dialogRef: MatDialogRef<any, R>, result?: R): void {
    dialogRef.close(result);
  }

  /**
   * Close all open modals
   */
  closeAllModals(): void {
    this.dialog.closeAll();
  }

  /**
   * Get all open modals
   */
  getopenDialogs(): MatDialogRef<any>[] {
    return this.dialog.openDialogs;
  }

  /**
   * Check if any modal is open
   */
  hasopenDialogs(): boolean {
    return this.dialog.openDialogs.length > 0;
  }

  /**
   * After all modals closed observable
   */
  afterAllClosed(): Observable<void> {
    return this.dialog.afterAllClosed;
  }
}
